import axios from 'axios';

import { urls } from '~/preloaded';
import settings from '~/settings';
import { TYPE_GLOBAL_SEARCH } from '~/constants';
import { get } from '~/helpers/api';
import { t } from '~/helpers/localization';
import { actionsSearch } from '~/Actions/ActionSearch';

import type { AppAsyncThunk } from '~/store';
import type { IApiClanSearchPayload, IApiClanSearchResponse } from '~/types/api';

interface IFetchSearchResult {
  type?: string;
  abortSignal?: AbortController['signal'];
}

export const fetchSearchResultThunk =
  ({ type, abortSignal }: IFetchSearchResult): AppAsyncThunk =>
  async (dispatch, getState) => {
    const state = getState();

    if (state.searchResult.isFetching) {
      return;
    }

    dispatch(actionsSearch.startFetching());
    const limit = settings.search.limit;

    let url: string;
    let query: IApiClanSearchPayload;

    if (type === 'clansRating') {
      url = urls.ladderClanSearch.replace('{query}', state.searchResult.term);
      query = {
        limit: limit,
        offset: (state.searchResult.page - 1) * limit,
        realm: state.clansRating.currentRealm || TYPE_GLOBAL_SEARCH,
        season: state.clansRating.currentSeason,
      };
    } else {
      url = urls.searchList;
      query = {
        battle_type: state.searchResult.battleTypeSelected,
        limit: limit,
        offset: (state.searchResult.page - 1) * limit,
        realm: state.clansRating.currentRealm || TYPE_GLOBAL_SEARCH,
        search: state.searchResult.term,
      };
    }

    try {
      const result = await get<IApiClanSearchResponse>(url, query, abortSignal && { signal: abortSignal });
      if (result.error) {
        dispatch(actionsSearch.updateError(result.error));
        return;
      }
      dispatch(actionsSearch.updateSearchResult(result));
    } catch (error: unknown) {
      if (!axios.isCancel(error)) {
        dispatch(
          actionsSearch.updateError({
            error: t('Произошла ошибка. Повторите попытку позже'),
          }),
        );
      }
    }
  };
